import React, { useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
} from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

const Block2 = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Box
            sx={{
                mt: {
                    xs: -14,
                    sm: -8,
                },
                height: {
                    xs: '60px',
                    sm: '100px',
                },
                boxShadow: {
                    xs: 'none',
                    sm: '0 0 12px rgba(0, 0, 0, 0.08)'
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: 'white',

            }}
        >
            <Button
                onClick={handleOpen}
                startIcon={<PlayCircleOutlineIcon />}
                sx={{

                    // fontSize: '1rem',
                    fontSize: {
                        xs: '0.9rem',
                        sm: '1rem',
                    },
                    padding: {
                        xs: '4px 14px',
                        sm: '10px 20px',
                    },
                    borderRadius: '50px',
                    backgroundColor: '#ffff',
                    border: '1px solid #dc5454',
                    color: '#dc5454',
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: '#ffff',
                        border: '1px solid #ca4141',
                        color: '#ca4141',
                        boxShadow: '0 0 12px rgba(0, 0, 0, 0.08)'
                    },
                }}
            >
                What is Travyx?
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen
                PaperProps={{ sx: { backgroundColor: 'black' } }}
            >
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 1,
                        zIndex: 1,
                        color: 'white',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent
                    sx={{
                        p: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                    }}
                >
                    <Box
                        component="iframe"
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/KJ-zvHIf2W4?autoplay=1&modestbranding=1&rel=0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        frameBorder="0"
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default Block2;
